/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSyncConfig } from '../../models/api-response-sync-config';

export interface SyncProduct$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function syncProduct(http: HttpClient, rootUrl: string, params: SyncProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSyncConfig>> {
  const rb = new RequestBuilder(rootUrl, syncProduct.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSyncConfig>;
    })
  );
}

syncProduct.PATH = '/v1/api/products/sync-products';
